/* Event report options */
import {helpers} from '@/ft-vue-core'

const {displayTime, displayDateTime} = helpers

export default {
  computed: {
    groupingOptions () {
      return [
        {
          id: 1,
          name: 'Location',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {return row.locationName},
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 2,
          name: 'Reservation Time',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime)
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 3,
          name: 'Location & Time',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime)
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 5,
          name: 'Location, Time & Reservation',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime)
              },
              emptyRows: this.reportFilters.emptyRows
            },
            {
              by: ['reservationId', 'ASC'],
              thinAggregate: true,
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => '#' + row.reservationId + ' Total'
            }
          ]
        },
        {
          id: 4,
          name: 'Time & Location',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime) + ' - ' + row.locationName
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 16,
          name: 'Event',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => row.eventName,
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 6,
          name: 'Event & Location',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => row.eventName + ' (' + row.locationName + ')',
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 7,
          name: 'Event & Reservation Time',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => row.eventName + ' (' + displayDateTime(row.dateTime) + ')',
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 8,
          name: 'Event, Location & Time',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.eventName + ' (' + row.locationName + ' - ' + displayDateTime(row.dateTime) + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 9,
          name: 'Event, Location, Time & Reservation',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.eventName + ' (' + row.locationName + ' - ' + displayDateTime(row.dateTime) + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            },
            {
              by: ['reservationId', 'ASC'],
              thinAggregate: true,
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => '#' + row.reservationId + ' Total'
            }
          ]
        },
        {
          id: 10,
          name: 'Event, Time & Location',
          group: [
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.eventName + ' (' + displayDateTime(row.dateTime) + ' - ' + row.locationName + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 11,
          name: 'Location & Event',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => row.locationName + ' (' + row.eventName + ')',
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 12,
          name: 'Reservation Time & Event',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => displayDateTime(row.dateTime) + ' (' + row.eventName + ')',
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 13,
          name: 'Location, Time & Event',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime) + ' (' + row.eventName + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        },
        {
          id: 14,
          name: 'Location, Time, Event & Reservation',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime) + ' (' + row.eventName + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            },
            {
              by: ['reservationId', 'ASC'],
              thinAggregate: true,
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => '#' + row.reservationId + ' Total'
            }
          ]
        },
        {
          id: 15,
          name: 'Time, Location & Event',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['eventName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.eventName + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime) + ' - ' + row.locationName + ' (' + row.eventName + ')'
              },
              emptyRows: this.reportFilters.emptyRows
            }
          ]
        }
      ]
    },
    columnOptions () {
      return this.baseColumnOptions.filter(c => ![18].includes(c.id)) // Exclude meal period name column
    }
  }
}
